<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'survey-template-list'"
    :loadDataGrid="loaded"
    :backButtonEnable="true"
    :backButtonRoute="'/settings/sales'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

import TransactionListTemplate from "@/templates/transaction-list";
import { FeatureStorage } from "@/_services/storage";
import { SurveyTemplateService } from "../../../_services/api/settings/sales/survey-template.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      loaded: false,
      gcPopupCustomerStatementConfig: {},
    };
  },
  computed: {
    defaultDateFilterValue() {
      let d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d;
    },
    setScreenConfig() {
      var config = {
        title: "Survey Templates",

        exportFileName: "Survey Template List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SurveyTemplate",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: ["RecordID"].concat(
                this.getSelectFields(this.getColumns)
              ),
              postProcessCallback: this.surveyTemplateListPostProcessCallback,
            },

            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Call Logs",
                message: "Get Started, Add a Call Log",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/survey-template/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "SurveyTemplate",
                  "create"
                ),
              },
            ],
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "SurveyName",
          label: "Survey Name",
          dataField: "SurveyName",
          dataType: "string",
          type: "Text",
          filterLabel: "Survey Name",
          filterIndex: 1,
          filterDataField: "SurveyName",
        },

        {
          screenField: "Date",
          dataField: "StartDate",
          filterDataField: "StartDate",
          label: "Start Date",
          filterLabel: "Start Date",
          filterIndex: 3,
        },
        {
          screenField: "Date",
          dataField: "EndDate",
          filterDataField: "EndDate",
          label: "End Date",
          filterLabel: "End Date",
          filterIndex: 4,
        },
        {
          screenField: "Date",
          sortOrder: "desc",
          dataField: "DateCreated",
          filterDataField: "DateCreated",
          label: "Created",
        },
        {
          screenField: "CreatedBy",
          dataField: "CreatedBy",
          filterDataField: "CreatedBy",
          label: "Created By",
          width: ColumnWidth.Username.width,
        },
        {
          screenField: "OrderStatus",
          gridDataField: "Status",
          gridLabel: "Status",
          dataField: "Status",
          filterDataField: "Status",
          filterIndex: 2,
          dataSourceConfig: {
            data: [
              { key: "N", value: "New" },
              { key: "A", value: "Active" },
              { key: "X", value: "Cancelled" },
            ],
          },
          valueExpr: "key",
          displayExpr: "value",
        },

        {
          screenField: "GridRecordEllipsisMenu",
          select: false,
          allowSearch: false,
          cssClass: "padding-7",
          ellipsisMenu: {
            itemAction: (data) => {
              var items = [
                {
                  menuText: "Cancel",
                  data: data,
                  clickAction: this.cancelSurveyTemplate,
                  disabled: false,
                },
              ];

              return items;
            },
            keyExpr: "menuText",
            displayExpr: "menuText",
          },
          dropDownOptions: {
            width: 100,
          },
          // eslint-disable-next-line no-unused-vars
          makeDisabled: (data) => {
            if (data) return data.data.Status != "N";
            else return true;
          },
        },
      ];
    },
  },
  methods: {
    surveyTemplateListPostProcessCallback(data) {
      data.forEach((element) => {
        if (element.StartDate)
          element.StartDate = element.StartDate.dateWithOffset();

        if (element.EndDate) element.EndDate = element.EndDate.dateWithOffset();

        if (element.DateCreated)
          element.DateCreated = element.DateCreated.dateWithOffset();
      });
      return data;
    },
    async cancelSurveyTemplate(e, grid) {
      // e.RecordId
      let confirmCancel = await this.$confirm(
        "Are you sure you wants to cancel this template ?",
        "Cancel Survey Template"
      );

      if (confirmCancel) {
        this.showLoading(true);
        await SurveyTemplateService.cancelSurveyTemplate({
          RecordId: e.RecordId,
        })
          .then((res) => {
            if (res) this.showLoading(false);

            grid.refresh(true);
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Cancel Failed");
            this.showLoading(false);
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `settings`,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "survey-template",
          mode: "review",
          idProperty: "RecordId",
        });
      }
    },
  },

  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
